export default __webpack_public_path__ + "navigation-examples-route-alerts-1200-0d668f161c69d513b7989b75799633cd.png";